import { format as e, parse as t } from "date-fns";

import { EMPTY_DATE_VAL as s } from "../constants/index.js";

const a = new Date, r = (e, t) => e >= t, n = (e, t) => e <= t, o = (e, ...t) => e, u = (...e) => !1, i = (e, t) => Array.from({
    length: e
}, ((e, s) => t(s))), l = e => e()
/*
https://github.com/date-fns/date-fns/blob/main/src/addMonths/index.ts
*/ , D = (e, t) => {
    a.setTime(e);
    const s = a.getDate();
    return a.setMonth(a.getMonth() + 1 + t, 0), s >= a.getDate() ? +a : a.setFullYear(a.getFullYear(), a.getMonth(), s);
}, g = (e, t) => D(e, 12 * t), c = e => (a.setTime(e), a.setHours(0, 0, 0, 0)), m = e => (a.setTime(e), 
a.setHours(23, 59, 59, 999)), f = e => (c(e), a.setDate(a.getDate() - a.getDay())), h = e => (c(e), 
a.setDate(1)), d = e => (m(e), a.setFullYear(a.getFullYear(), a.getMonth() + 1, 0)), T = () => c(Date.now()), w = e => (c(e), 
a.setMonth(0, 1)), M = e => (m(e), a.setMonth(11, 31)), p = (e, t) => (a.setTime(e), 
a.setDate(a.getDate() + t)), F = e => (m(e), a.setDate(6 + a.getDate() - a.getDay())), y = e => (a.setTime(e), 
a.getMonth()), Y = (e, t, s, o) => {
    if (t !== e) {
        a.setTime(e);
        const o = t > e ? n : r, u = t > e ? 1 : -1;
        for (let r = 0, n = e; o(n, t) && r++ < 512; n = a.setDate(a.getDate() + u)) if (!s(n)) return n;
    }
    a.setTime(e);
    for (let t = 0, r = e; t++ < 512; r = a.setDate(a.getDate() + o)) if (!s(r)) return r;
}, b = e, j = (e, s) => (a.setTime(0), t(e, s, a)), x = (e, t, a, r) => {
    switch (e) {
      case void 0:
      case null:
      case "":
        return s;

      default:
        switch (typeof e) {
          case "number":
            return e;

          case "string":
            const n = a(e, t);
            return r(n) ? +n : s;

          case "object":
            return e instanceof Date ? +e : s;

          default:
            return s;
        }
    }
}, H = (e, t, s, a = !1) => {
    const r = Date.now();
    return a ? "" : s && e > r ? "Future dates are not allowed" : t && e < r ? "Past dates are not allowed" : "";
};

export { p as addDays, D as addMonths, g as addYears, l as call, m as endOfDay, d as endOfMonth, F as endOfWeek, M as endOfYear, Y as findDayNot, b as format, H as getInputValueError, y as getMonth, o as identity, j as parse, x as parseValue, c as startOfDay, h as startOfMonth, T as startOfToday, f as startOfWeek, w as startOfYear, u as stubFalse, i as times };
//# sourceMappingURL=index.js.map
